import { render, staticRenderFns } from "./SendTokensVideoCallRoomModal.vue?vue&type=template&id=5f36f87a&scoped=true&"
import script from "./SendTokensVideoCallRoomModal.vue?vue&type=script&lang=js&"
export * from "./SendTokensVideoCallRoomModal.vue?vue&type=script&lang=js&"
import style0 from "./SendTokensVideoCallRoomModal.vue?vue&type=style&index=0&id=5f36f87a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36f87a",
  null
  
)

export default component.exports